<template>
  <div :style="{'min-height': (minHeight - 10) + 'px'}" id="myhead">
    <div>
      <div class="logoPlace">
        <p style="background: #000;opacity: 0.6" class="p_a p_all"></p>
      </div>
      <ul class="menuPlace" style="padding: 20px 0px 20px 0px;position: relative;">
        <li v-if="object.showMenu" :class="object.active && object.active.indexOf(activeHtml) >= 0 && activeHtml !== '' ? 'active' : '' " :key="index" v-for="( object , index) in menuList" @click="toUrL(object.url)">
          <span  @click="activeHtml = object.active">
            <i class="m_r_10" :class="object.iconName"></i>
            <span style="display: inline-block;width: 70px">{{object.menuName}}</span>

          </span>
        </li>
      </ul>
    </div>
  </div>

</template>

<script>
let timeCount
export default {
  name: 'myhead',
  props: [
    'minHeight'
  ],
  data () {
    return {
      isSystemAdmin: window.sessionStorage.getItem('isSystemAdmin'),
      userInfo: JSON.parse(window.sessionStorage.getItem('userInfo')),
      nowApp: JSON.parse(window.sessionStorage.getItem('nowApp')),
      showTip: true,
      todoLength: '',
      minWidth: '',
      activeHtml: '',
      fatherHtml: '',
      menuList: [
        {
          active: 'newMyIndex',
          iconName: 'icon iconfont iconhome-select',
          name: '主页',
          url: 'newMyIndex',
          showMenu: false,
          // AppOwner: true,
          GroupOwner: true,
          ContentOwner: true
          // isSys: true
        },
        {
          active: 'contenListCommentListContentReleasecommentListMaterialLibraryeditContListContentReleaseListproductList',
          iconName: 'icon iconfont iconneirong',
          name: '内容管理',
          url: 'contenList',
          showMenu: false,
          AppOwner: true,
          ContentOwner: true,
          GroupOwner: true,
          ContentEditor: true
        },
        {
          active: 'userListwhiteList',
          iconName: 'icon iconfont iconusers',
          name: '推送管理',
          url: 'userList',
          showMenu: false,
          AppOwner: true,
          isSys: true
        },
        {
          active: 'mainDateListContentListcategoryListeditMainDateListeditCategoryList',
          iconName: 'icon iconfont iconshuju',
          name: '分组管理',
          url: 'mainDateList',
          showMenu: false,
          AppOwner: true,
          isSys: true,
          ContentOwner: true,
          GroupOwner: true,
          ContentEditor: true
        },
        {
          active: 'userListwhiteList',
          iconName: 'icon iconfont iconusers',
          name: 'HCP管理',
          url: 'userList',
          showMenu: false,
          AppOwner: true,
          isSys: true
        },
        {
          active: 'burialPointRecordMangerburialPointArticleLogburialPointSearchHistoryburialPointActionHistory',
          iconName: 'icon iconfont iconusers',
          name: '数据埋点记录',
          url: 'burialPointArticleLog',
          showMenu: false,
          AppOwner: true,
          isSys: true
        },
      ]
    }
  },
  created () {
    let menuList = window.localStorage.getItem('usermenus') ? JSON.parse(window.localStorage.getItem('usermenus')) : ''
    if (menuList) {
      for (let i = 0; i < menuList.length; i++) {
        for (let j = 0; j < menuList[i].tabMenus.length; j++) {
          if (menuList[i].tabMenus[j].isSelected) {
            menuList[i].url = menuList[i].tabMenus[0].url
          }
        }
        menuList[i].showMenu = true
        if (menuList[i].menuName === '内容管理') {
          menuList[i].active = 'contenListCommentListcommentListMaterialLibraryeditContListproductListcategoryNewListcontentReadAlllifecyclePagebuBrandListcontenOperateLog'
          menuList[i].iconName = 'icon iconfont iconneirongguanli'
        }
        if (menuList[i].menuName === '推送管理') {
          menuList[i].active = 'mainDateListContentListcategoryListeditMainDateListeditCategoryListContentReleaseContentReleaseListarticleReports'
          menuList[i].iconName = 'icon iconfont icontuisongguanli'
        }
        if (menuList[i].menuName === 'HCP管理') {
          menuList[i].active = 'userListuserDetailoperationLogsnonHCPListoperationLogs_nonHCP'
          menuList[i].iconName = 'icon iconfont iconyishengtuanduiziyuan'
        }
        if (menuList[i].menuName === '权限管理') {
          menuList[i].active = 'AllauthorityListmyPersonalRoleList'
          menuList[i].iconName = 'icon iconfont iconquanxianguanli1'
        }
        if (menuList[i].menuName === '视频管理') {
          menuList[i].active = 'videoManagercarouselListvideoList'
          menuList[i].iconName = 'icon iconfont iconshipin3'
        }
        if (menuList[i].menuName === '消息管理') {
          menuList[i].active = 'messagePushingmeetingPushingmessageLog'
          menuList[i].iconName = 'icon iconfont iconxiaoxiguanli'
        }
        if (menuList[i].menuName === '调研管理') {
          menuList[i].active = 'surveryListsurveryData'
          menuList[i].iconName = 'icon iconfont icondaishenpi'
        }
        if (menuList[i].menuName === '渠道二维码管理') {
          menuList[i].active = 'qrCodeManagerchannelQrCodechannelFollowListfollowDetailListregisterDetailList'
          menuList[i].iconName = 'icon iconfont iconqrcode'
        }
        if (menuList[i].menuName === '自动回复配置') {
          menuList[i].active = 'autoReplyManagerkeyWordList'
          menuList[i].iconName = 'icon iconfont iconzidonghuifushezhi'
        }
        if (menuList[i].menuName === '标签管理') {
          menuList[i].active = 'tagManagertagListaiTagList'
          menuList[i].iconName = 'icon iconfont iconbiaoqian1'
        }
        if (menuList[i].menuName === '话题管理') {
          menuList[i].active = 'topicManagertagList'
          menuList[i].iconName = 'icon iconfont iconzidonghuifushezhi'
        }
        if (menuList[i].menuName === '适应症管理') {
          menuList[i].active = 'indicationsManagertagList'
          menuList[i].iconName = 'icon iconfont iconzidonghuifushezhi'
        }
        if (menuList[i].menuName === '直播管理') {
          menuList[i].active = 'onManagementonLiveList'
          menuList[i].iconName = 'icon_onLive'
        }
        if (menuList[i].menuName === '文章集锦配置管理') {
          menuList[i].active = 'articleManagetakedaArticleManagetakedaCountyManage'
          menuList[i].iconName = 'icon_articleManage'
        }
        if (menuList[i].menuName === '跳转配置') {
          menuList[i].active = 'feedFlareManagefeedFlareList'
          menuList[i].iconName = 'icon_feedFlareManage'
        }
        if (menuList[i].menuName === '聚合页管理') {
          menuList[i].active = 'aggregateListaggregateManager'
          menuList[i].iconName = 'icon iconfont iconbiaoqian1'
        }
        if(menuList[i].menuName === '数据埋点记录'){
          menuList[i].active = 'burialPointRecordMangerburialPointArticleLogburialPointSearchHistoryburialPointActionHistory'
          menuList[i].iconName = 'icon iconfont iconbiaoqian1'
        }
      }

      this.menuList = menuList

      // 删除注释
    // const olds =  {
    //       menuType: "Default",
    //       isSelected: true,
    //       id: 196,
    //       url: "indicationsManager",
    //       description: "适应症管理",
    //       menuName: "适应症管理",
    //       parentMenuId: 0,
    //       childMenus: null,
    //       tabMenus: [],
    //       buttonMenus: [],
    //       showMenu: true,
    //       active: "indicationsManagertagList",
    //       iconName: "icon_articleManage"
    //   }
    //     this.menuList.push(olds)
        
      // test
      // let item = {
      //   active: 'contenListCommentListcommentListMaterialLibraryeditContListproductListcategoryNewListcontentReadAll',
      //   buttonMenus: [],
      //   childMenus: null,
      //   description: '消息管理',
      //   iconName: 'icon iconfont iconneirongguanli',
      //   id: 99,
      //   isSelected: true,
      //   menuName: '消息管理',
      //   menuType: 'Default',
      //   parentMenuId: 0,
      //   showMenu: true,
      //   tabMenus: [
      //     {
      //       buttonMenus: null,
      //       childMenus: null,
      //       description: '消息推送',
      //       id: 100,
      //       isSelected: true,
      //       menuName: '消息推送',
      //       menuType: 'Tab',
      //       parentMenuId: 99,
      //       tabMenus: null,
      //       url: 'messagePushing'
      //     },
      //     {
      //       buttonMenus: null,
      //       childMenus: null,
      //       description: '会议推送',
      //       id: 101,
      //       isSelected: true,
      //       menuName: '会议推送',
      //       menuType: 'Tab',
      //       parentMenuId: 99,
      //       tabMenus: null,
      //       url: 'meetingPushing'
      //     },
      //     {
      //       buttonMenus: null,
      //       childMenus: null,
      //       description: '消息日志',
      //       id: 102,
      //       isSelected: true,
      //       menuName: '消息日志',
      //       menuType: 'Tab',
      //       parentMenuId: 99,
      //       tabMenus: null,
      //       url: 'messageLog'
      //     }
      //   ],
      //   url: 'messagePushing'
      // }
      // this.menuList.push(item)
      //testEnd
      let permission = false
      for (let i = 0; i < menuList.length; i++) {
        if (menuList[i].active && menuList[i].active.indexOf(this.$route.name) >= 0) {
          permission = true
        }
      }
      // if (!permission) {
      //   this.$router.push({
      //     name: 'noPermission'
      //   })
      // }
      window.localStorage.setItem('menuList', JSON.stringify(this.menuList))
    } else {
      this.$router.push({name: 'noPermission'})
    }
    timeCount = setInterval(p => {
      this.changeSelUrl()
    }, 100)
    console.log('newmenus',this.menuList)
  },
  destroyed () {
    clearInterval(timeCount)
  },
  mounted () {
    this.minWidth = window.innerWidth
    console.log('menulist', this.menuList)
  },
  methods: {
    getAllmenu () {
      this.$axiox.get('/api/authoritymenu/GetAllMenus/menus').then(p => {
        for (let i = 0; i < p.length; i++) {
          p[i].showMenu = true
          if (i === 0) {
            p[i].active = 'contenListCommentListcommentListMaterialLibraryeditContListproductListcategoryNewListcontentReadAllcontenOperateLog'
            p[i].iconName = 'icon iconfont iconneirong'
          }
          if (i === 1) {
            p[i].active = 'mainDateListContentListcategoryListeditMainDateListeditCategoryListContentReleaseContentReleaseList'
            p[i].iconName = 'icon iconfont iconyingyongguanli'
          }
          if (i === 2) {
            p[i].active = 'userListuserDetail'
            p[i].iconName = 'icon iconfont iconwendangguanlixitong-shujuzhongxintubiao'
          }
          if (i === 3) {
            p[i].active = 'AllauthorityList'
            p[i].iconName = 'icon iconfont iconquanxian1'
          }
        }
        this.menuList = p
        console.log(this.menuList)
        window.sessionStorage.setItem('menuList', JSON.stringify(this.menuList))
      })
    },
    changeSelUrl () {
      if (this.$route.query.from !== '' && this.$route.query.from !== undefined) {
        this.activeHtml = this.$route.query.from
      } else {
        this.activeHtml = this.$route.name
      }
    },
    toUrL (urlType) {
      console.log(urlType)
      this.activeHtml = urlType
      this.$router.push({
        name: urlType
      })
    }
  }
}
</script>

<style scoped>
  #myhead{
  width: 100%;
  background-color: #fff;
  margin-top: 15px;
  margin-left: 20px;
  margin-bottom: 20px;
  }
  .header{
   position: relative;
   left: 0px;
   right: 0px;
   width: 1450px;
    height: 80px;
    background-color: #000;
    z-index: 10;
    margin-bottom: 20px;
  }
  .logoPlace{
    position: relative;
    text-align: center;
  }
  .logoPlace .textPlace{
    padding: 10px 0;
    color: #fff;
    position: relative;
    z-index: 1;
  }
  .userInfoPlace{
    margin: 0 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #fff;
  }
  .userInfoPlace > img{
    width: 70px;
    height: 70px;
    border-radius: 70px;
    margin: 20px 0;
  }
  .menuPlace li{
    text-align: left;
    font-size: 16px;
    padding: 20px 0px 20px 30px;
    height: 20px;
    line-height: 15px;
    /* padding-left: 0px; */
    /* border-radius: 100px 0 0 100px; */
    transition: all 0.2s;
  }
  .menuPlace li.active{
    background: #ffeeee;
    color: #ee1100;
    width: 100%;
  }
  .notice{
    border:1px solid #FF7F41;
    padding: 5px 7px;
    background: #FF7F41;
    color: #fff;
    border-radius: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/left-menu/menu.vue